import { ThunkAction, UnknownAction } from '@reduxjs/toolkit'
import { ActivityEnum, StageName } from '@shared/Enums'
import { dispatchError, OtDispatch, OtStoreState } from '@react/redux/store'

import { chainActions, locationToStageName } from '@react/redux/chainSlice'

import { logOT } from '@shared/loggingShared'

import { poolActions } from '@react/redux/poolSlice'
import { createClientWebsocketHandler } from '@react/redux/wsClient'
import { findStageConfiguration } from '@shared/DeploymentConfigs'
import { StageConfiguration } from '@shared/DeploymentConfigTypes'

//
export const changeStageThunk =
  (props: { stageName: StageName }): ThunkAction<void, OtStoreState, unknown, UnknownAction> =>
  async (dispatch, _getState): Promise<void> => {
    const { stageName } = props

    try {
      const { stageConfiguration } = await attachToStage(stageName)

      dispatch(chainActions.attachToStageConfiguration({ stageConfiguration }))

      dispatch(poolActions.finishedInitializing())
    } catch (e: any) {
      await dispatchError(dispatch, e, ActivityEnum.DEPLOYMENT_CONFIGURATION, 1021)
    }
  }

export const attachToStageThunk =
  (props: { stageName: StageName }): ThunkAction<void, OtStoreState, unknown, UnknownAction> =>
  async (dispatch, _getState): Promise<void> => {
    const { stageName } = props

    try {
      const { stageConfiguration } = await attachToStage(stageName)
      logOT.debug('attachToStageThunk', stageName, stageConfiguration)

      dispatch(chainActions.attachToStageConfiguration({ stageConfiguration }))

      dispatch(poolActions.finishedInitializing())
    } catch (e: any) {
      await dispatchError(dispatch, e, ActivityEnum.DEPLOYMENT_CONFIGURATION, 1021)
    }
  }

export const jestReactAttachToStage = async (
  dispatch: OtDispatch,
  stageName: StageName,
  chainConfigurationName: string
) => {
  logOT.info('jestReactAttachToDeployment START')

  dispatch(chainActions.unattachFromStageConfiguration())

  try {
    const { stageConfiguration } = await attachToStage(stageName)

    // const providerReadOnly = new ethers.JsonRpcProvider(
    //   chainDeployment.providerReadUrl,
    //   new Network(chainDeployment.chainName, chainDeployment.chainId),
    //   {
    //     //staticNetwork: true,
    //     pollingInterval: 100,
    //     polling: false,
    //     batchMaxCount: 1,
    //   }
    // )

    dispatch(chainActions.attachToStageConfiguration({ stageConfiguration }))

    dispatch(poolActions.finishedInitializing())

    logOT.debug('jestReactAttachToDeployment PRE CONNECT', stageConfiguration.websocketUrl)
    const webSocket = await createClientWebsocketHandler(
      stageConfiguration.websocketUrl,
      dispatch,
      chainConfigurationName
    )

    logOT.debug('jestReactAttachToDeployment POST CONNECT', !!webSocket)
  } catch (e: any) {
    console.error('jestReactAttachToDeployment ERROR', e)
  }
}

export async function attachToStage(stageName?: StageName): Promise<{ stageConfiguration: StageConfiguration }> {
  logOT.debug('attachToStage', stageName)

  const stageConfiguration = findStageConfiguration(stageName ?? locationToStageName(location))

  return { stageConfiguration }
}
